export default __webpack_public_path__ + "static/media/6-min.d4c19017.PNG";